// @ts-nocheck
/**
 * listView paint projection for item.documents — names + datetime/size subtitles.
 * BindingResolver still returns raw paths for getItemData / other consumers.
 */

import type { ItemDefinition } from '../../../../../shims/appStub';
import { alignDocumentArrays } from '../../../../../shims/appStub';
import { formatDocumentListViewSubtitle } from '../../../../../shims/appStub';
import type { DataRef, ValueSource } from '../../types/canonical';

export function isDocumentsItemFieldSource(
  source: ValueSource<unknown> | undefined,
): boolean {
  if (source == null || source.kind !== 'binding') {
    return false;
  }
  const ref = source.ref as DataRef | undefined;
  return ref?.kind === 'itemField' && ref.field === 'documents';
}

export function projectDocumentListView(item: ItemDefinition): {
  entries: string[];
  subtitles: string[];
} {
  const aligned = alignDocumentArrays(item);
  return {
    entries: aligned.documentNames,
    subtitles: aligned.documents.map((_, index) =>
      formatDocumentListViewSubtitle(
        aligned.documentDates[index] ?? 0,
        aligned.documentSizes[index] ?? 0,
      ),
    ),
  };
}
